import React from 'react'

function List({ list }) {
    list = list
    .replace('<ul>', '<ul class="list-disc">')
    .replaceAll('<li>', '<li class="text-left">')
    .replaceAll('<strong>', '<strong class="font-bold">')
  return (
    <div dangerouslySetInnerHTML={{__html: list}} className="flex flex-col justify-center italic text-[14px] lg:text-3xl"/>
  )
}

export default List